import React from "react";

const Disclaimer = () => {
  return (
    <small>
      <em>
        <strong>Note:</strong> Responses are not saved and cannot be seen by
        anyone you have not shared with. Responses that you build are private
        and are not recorded in any way, shape, or form.
        <br></br>
      </em>
    </small>
  );
};

export default Disclaimer;
